import { render } from "./folderList.vue?vue&type=template&id=d8079a90"
import script from "./folderList.vue?vue&type=script&lang=js"
export * from "./folderList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/grgnd.webweb.works/client/grapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__